module.exports = __webpack_public_path__ + "img/ic_96_smiley.94fa85d0.png";